import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Button from 'material-ui/Button';
import Console from '../../lib/debug';
import AppStatus from '../common/AppStatus';
import Notifications from '../../v5/notifications/components/Notifications';
import UpgradeButton from './UpgradeButton';
import LoggedInUserAvatar from './LoggedInUserAvatar';

import * as AppState from '../../state/reducer/app/appState';
import MessagingButton from '../../v5/messaging/components/MessagingButton';
import AssistantCoachButton from './AssistantCoachButton';
import TermsOfUsePrompt from '../../v5/termsOfUse/components/TermsOfUsePrompt';

export default class BreadcrumbNav extends Component {
    componentDidMount() {
        const navBar = document.getElementById('loading-nav-bar');
        navBar && navBar.classList.remove('loading-nav-bar');
    }

    generateCrumbVisuals(crumbDataArray) {
        return (
            <div>
                {crumbDataArray.map((crumb, index) => {
                    let isLast = index === crumbDataArray.length - 1;
                    let hasLink = crumb.link;
                    const key = 'bc' + index;
                    if (hasLink) {
                        return (
                            <div key={key}>
                                <span key={crumb.displayString}>
                                    <Button
                                        onClick={() => {
                                            AppState.navigate(crumb.link);
                                        }}
                                        style={{
                                            color: 'inherit',
                                            fontFamily: 'inherit',
                                            fontSize: '20px'
                                        }}
                                    >
                                        <span>{crumb.displayString}</span>
                                    </Button>
                                </span>
                                {isLast ? null : (
                                    <i className="mdi mdi-chevron-right" />
                                )}
                            </div>
                        );
                    } else {
                        return (
                            <div key={key}>
                                <span key={crumb.displayString}>
                                    <Button
                                        style={{
                                            color: 'inherit',
                                            fontFamily: 'inherit',
                                            fontSize: '20px'
                                        }}
                                    >
                                        {crumb.displayString}
                                    </Button>
                                </span>
                                {isLast ? null : (
                                    <i className="mdi mdi-chevron-right" />
                                )}
                            </div>
                        );
                    }
                })}
                {crumbDataArray.length > 0 && this.props.children ? (
                    <i className="mdi mdi-chevron-right" />
                ) : null}
                {this.props.children}
            </div>
        );
    }

    render() {
        Console.render('BreadcrumbNav');

        return (
            <AppBar position="fixed" className="breadcrumb-bar">
                <Toolbar disableGutters={true}>
                    <div className="overall-container">
                        <div className="left-container">
                            {this.generateCrumbVisuals(this.props.crumbs)}
                        </div>
                        <div className="right-container">
                            <AppStatus />
                            <AssistantCoachButton />
                            <UpgradeButton />
                            <MessagingButton />
                            <Notifications />
                            <LoggedInUserAvatar />
                        </div>
                    </div>
                </Toolbar>
            </AppBar>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/nav/BreadcrumbNav.jsx